/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ExchangeRateTypeEnum {
    Sell = 100,
    Buy = 200,
}
